import React from "react";
import PropTypes from "prop-types";
import Icon from "../Icon";

function VideoPreview({ selectedImages = [], onDelete }) {
  return (
    <>
      {selectedImages.map((file, idx) => (
        <div
          key={idx}
          className="image-wrapper d-flex align-items-center"
        >
          <video
            src={file.preview}
            controls
            style={{
              width: 200,
              height: 100,
              objectFit: 'cover',
              background: '#000',
              flexShrink: 0
            }}
          />
          <section className="px-3 d-flex justify-content-between align-items-center w-100">
            <section className="d-flex flex-column justify-content-center">
              <label className="text-secondary mt-1 text-truncate" style={{ maxWidth: '20vw' }}>{file.name || file.file?.name}</label>
              <label className="font-weight-semibold mb-0">
                {file.size ? `${(file.size / 1000).toFixed(2)} KB` : file.bytes ? `${(file.bytes / 1000).toFixed(2)} KB` : 'Unknown size'}
              </label>
            </section>
            {onDelete && (
              <Icon icon="trashIcon" className="cursor-pointer ms-3" onClick={() => onDelete(idx)} />
            )}
          </section>
        </div>
      ))}
    </>
  );
}

VideoPreview.propTypes = {
  selectedImages: PropTypes.array,
  onDelete: PropTypes.func
};

export default VideoPreview;
